import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function Emphasize(_a) {
    var target = _a.target;
    if (target.indexOf('<em>') === -1) {
        return _jsx(_Fragment, { children: target });
    }
    return (_jsx(_Fragment, { children: target.split('<em>').reduce(function (acc, str, i) {
            var _a = str.split('</em>'), before = _a[0], after = _a[1];
            if (after) {
                acc.push(_jsx("em", { children: before }, "".concat(i, "-").concat(before)));
                acc.push(after);
            }
            else if (before) {
                acc.push(before);
            }
            return acc;
        }, []) }));
}
//# sourceMappingURL=Emphasize.js.map